<template>
    <div :class="{ 'coupon-item' : true, 'disabled' : couponInfo.status !== '0' }" @click="$emit('click', couponInfo)">
        <van-row align="center">
            <van-row type="flex" justify="center" style="padding-top: 0.5rem">
                <van-col :span="7" class="coupon-item-left">
                    <template v-if="couponInfo.coupon.template.type === 'reduction'">
                        <div class="coupon-item-price">
                            <span class="coupon-item-unit">￥</span>{{couponInfo.coupon.template.rule.reduce}}
                        </div>
                    </template>
                    <template v-else-if="couponInfo.coupon.template.type === 'full_reduction'">
                        <div class="coupon-item-price">
                            {{couponInfo.coupon.template.rule.reduce}}<span class="coupon-item-unit">元</span>
                        </div>
                    </template>
                    <template v-else-if="couponInfo.coupon.template.type === 'discount'">
                        <div class="coupon-item-price">
                            {{couponInfo.coupon.template.rule.discount}}<span class="coupon-item-unit">折</span>
                        </div>
                    </template>
                </van-col>  
                <van-col :span="couponInfo.status === '0' ? 10 : 17" style="align-self: start;">
                    <div class="coupon-item-title">{{couponInfo.coupon.template.name}}</div>
                </van-col>
                <van-col v-if="couponInfo.status === '0'" :span="7" style="text-align: center;">
                    <van-button plain round size="small" @click="goToUse" class="coupon-item-button">立即使用</van-button>
                </van-col>
            </van-row>
            <van-row style="margin-top: 0.1rem;padding-bottom: 0.3rem">
                <van-col :span="7" class="coupon-item-left">
                    <template v-if="couponInfo.coupon.template.type === 'reduction'">
                        <div class="coupon-item-price-text">无门槛券</div>
                    </template>
                    <template v-else-if="couponInfo.coupon.template.type === 'full_reduction'">
                        <div>满{{couponInfo.coupon.template.rule.full_condition}}元可用</div>
                    </template>
                    <template v-else-if="couponInfo.coupon.template.type === 'discount'">
                        <div>满{{couponInfo.coupon.template.rule.full_condition}}元可用</div>
                        <div v-if="couponInfo.coupon.template.rule.max_deduction">
                            最高可扣{{couponInfo.coupon.template.rule.max_deduction}}元
                        </div>
                    </template>
                </van-col>
                <van-col :span="17" style="align-self: start;">
                    <div class="coupon-item-describe">仅限制“{{$store.state.systemEnum['company']['coupon_template']['use_scene'][couponInfo.coupon.template.use_scene]}}”场景使用</div>
                </van-col>
            </van-row>
        </van-row>
        <div class="coupon-item-time">
            <span class="time-text">使用时间：{{couponInfo.start_time}} ~ {{couponInfo.expire_time}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Coupon",
        props: {
            couponInfo: {
                type: Object,
                default(){
                    return {};
                },
            },
        },
        methods : {
            goToUse(){
                let use_scene = this.couponInfo.coupon.template.use_scene;
                if(use_scene === 'consume'){
                    this.$router.push({
                        name : 'Oiling',
                    });
                }else if(use_scene === 'recharge'){
                    this.$router.push({
                        name : 'Recharge',
                    });
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
@import '../../style/themeify.scss';
    *{
        @include themeify{
            .coupon-item{
                background-color: #ffffff;
                border-radius: 0.3rem;

                &.disabled{
                    color: #999999;
                    .coupon-item-left{
                        color: #999999;
                    }
                }

                .coupon-item-left{
                    text-align: center;
                    font-size: 12px;
                    color: themed('colorText');

                    .coupon-item-price{
                        display: block;
                        font-size: 0.7rem;
                        font-weight: bold;
                    }
                    .coupon-item-unit{
                        font-size: 0.5rem;
                        margin-right: 3px;
                    }
                }
                .coupon-item-title{
                    font-size: 16px;
                    font-weight: bold;
                }
                .coupon-item-describe{
                    font-size: 12px;
                    color: #868686;
                }
                .coupon-item-button {
                    border-color: themed('colorButton');
                    color: themed('colorButton');
                }
                .coupon-item-time{
                    font-size: 12px;
                    padding-top: 0.2rem;
                    border-top: 1px dashed #cccccc;
                    margin-top: 10px;
                    padding-bottom: 0.2rem;
                    color: #999;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: #f3f3f3;

                    .time-text {
                        display: block;
                    }
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/coupon/Coupon.vue